const dateFormat = new Intl.DateTimeFormat(undefined, { dateStyle: "medium" });

export function formatDate(epochMs: number): string {
  return dateFormat.format(new Date(epochMs));
}
